export interface UserRole {
    id: string;
    updated_at: Date;
    created_at: Date;
    is_active: boolean;
    name: string;
    type: number;
    description: string;
    read_only: boolean;
    created_by: string;
    updated_by: string
}

export const USER_ROLE_TYPE_INTERNAL = 1000;
export const USER_ROLE_TYPE_EXTERNAL = 2000;